// extracted by mini-css-extract-plugin
export default {"wrap":"qty-selector_wrap__OA9Rs","minus":"qty-selector_minus__vit0H","plus":"qty-selector_plus__blvMA"};